<template>
  <AppSection id="privacy-policy" :title="$getConst.pages.policies.terms_and_conditions" type="page">
    <div v-if="!isLoading && terms.length>0">
      <div v-if="!terms.includes('FileBase64')" v-html="terms"></div>
      <div v-else>
        <a class="visitLink" @click="downloadFile"> {{$t($getConst.pages.terms_and_conditions.find_our_terms)}}</a>
      </div>
    </div>
    <div v-else-if="error !== null">
      <h3 class="pt-3">{{error}}</h3>
    </div>
    <div v-if="isLoading">
      <AppSpinner size="3" class="d-block m-4 mx-auto text-secondary"/>
    </div>
  </AppSection>
</template>
<script>
import {
  getTermsOrPrivacyPolicyByConnectedScopeAndLanguage,
  getTermsOrPrivacyPolicyContent
} from "../../../../../api/policies.api";
  import AppSection from "../../../../../components/common/sections/AppSection";
  import AppSpinner from "../../../../../components/common/utils/AppSpinner";

  export default {
    name: 'index',
    components: {AppSpinner, AppSection},
    data() {
      return {
        terms:[],
        isLoading: false,
        error:null,
        isCreated: true,

      }
    },

    created() {
      if( this.$store.getters['scope/isScopeLanguages'] || this.$store.getters['auth/isAuthenticated']) {
        this.getPolicyOfSelectedLanguage()
      } else {
        this.getPolicyOfDefaultLanguage();
      }
     },
    methods: {
      openFile(){
        let win = window.open();
        if (win != null) {
        win.document.write(
          '<iframe src="' +
          `data:application/pdf;base64,${JSON.parse(this.terms).FileBase64}` +
          '" frameborder="0" ' +
          'style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen>' +
          '</iframe>'
        );
        win.document.title = 'Hays Timesheet - Terms';
        win.document.close();
      }
      },
      downloadFile() {
            const linkSource = `data:application/pdf;base64,${JSON.parse(this.terms).FileBase64}`;
            const downloadLink = document.createElement("a");
            const fileName =`${JSON.parse(this.terms).FileName}`;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();


      },
      getPolicyOfDefaultLanguage() {
        this.isLoading = true;
        getTermsOrPrivacyPolicyContent().then(
          (response) => {
            this.isLoading= false;
            this.terms = response.data.terms;
            if(this.terms.includes('FileBase64')){
              this.openFile();
            }
            this.isCreated = false;
          },
          (error) => {
            this.handleApiError(error);
            this.isLoading= false;
            this.isCreated = false;
            this.error = this.$t(this.$getConst.pages.alerts.unknown_error);
          }
        )
      },
      getPolicyOfSelectedLanguage() {
        this.isLoading = true;
        getTermsOrPrivacyPolicyByConnectedScopeAndLanguage(this.$i18n.locale, 'terms').then(
          (response) => {
            this.isLoading= false;
            this.isCreated = false;
            this.terms = response.data[0].terms;
            if(this.terms.includes('FileBase64')){
              this.openFile();
            }
          },
          (error) => {
            this.handleApiError(error);
            this.isLoading= false;
            this.isCreated = false;
            this.error = this.$t(this.$getConst.pages.alerts.unknown_error);
          }
        )
      }

    },
    watch: {
      '$i18n.locale': {
        handler: function() {
          if (!this.$store.getters['auth/isAuthenticated'] && !this.isCreated) {
            this.getPolicyOfSelectedLanguage();
          }
        },
        deep: true,
      }
    }
  }
</script>
<style>
  .visitLink {
    text-decoration:none;
  }
  .visitLink:hover {
    text-decoration:underline;
    color: #002776;
  }
</style>
